import _slicedToArray from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _toConsumableArray from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _createForOfIteratorHelper from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
import _regeneratorRuntime from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { _ as e } from "../chunks/tslib.es6.js";
import r from "../core/CollectionFlattener.js";
import i from "../core/Error.js";
import { HandleOwner as t } from "../core/HandleOwner.js";
import a from "../core/Logger.js";
import { someMap as s } from "../core/MapUtils.js";
import { isNone as o, isSome as l, removeMaybe as n } from "../core/maybe.js";
import { createDeferred as y, isAbortError as h, onAbort as p, throwIfAborted as w } from "../core/promiseUtils.js";
import { schedule as c } from "../core/scheduling.js";
import { on as d, init as m } from "../core/watchUtils.js";
import { property as u } from "../core/accessorSupport/decorators/property.js";
import "../core/arrayUtils.js";
import "../core/has.js";
import "../core/accessorSupport/ensureType.js";
import { subclass as f } from "../core/accessorSupport/decorators/subclass.js";
import { WatchUpdatingTracking as v } from "./support/WatchUpdatingTracking.js";

var _ = a.getLogger("esri.views.LayerViewManager");

var g = /*#__PURE__*/function () {
  function g(e, r, t) {
    var _this = this;

    _classCallCheck(this, g);

    this.layer = e, this.view = r, this.layerViewImporter = t, this._controller = new AbortController(), this._deferred = y(), this._started = !1, this.done = !1, p(this._controller.signal, function () {
      var r = new i("cancelled:layerview-create", "layerview creation cancelled", {
        layer: e
      });

      _this._deferred.reject(r);
    });
  }

  _createClass(g, [{
    key: "promise",
    get: function get() {
      return this._deferred.promise;
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this._controller.abort();

      var e = this.layerView;
      if (!e) return;
      var r = this.layer,
          i = this.view;
      r.emit("layerview-destroy", {
        view: i,
        layerView: e
      }), i.emit("layerview-destroy", {
        layer: r,
        layerView: e
      }), this.done = !0, this.layer = null, this.layerView = null, this.view = null, this.layerViewImporter = null;
    }
  }, {
    key: "start",
    value: function () {
      var _start = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _this2 = this;

        var e, r, t, a, s, _l, _y, _a, _h;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!this._started) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return");

              case 2:
                this._started = !0;
                e = this._controller.signal, r = this.layer, t = this.view;
                this._map = t.map;
                _context.prev = 5;
                _context.next = 8;
                return r.load({
                  signal: e
                });

              case 8:
                _context.t0 = "prefetchResources" in r;

                if (!_context.t0) {
                  _context.next = 12;
                  break;
                }

                _context.next = 12;
                return r.prefetchResources({
                  signal: e
                });

              case 12:
                if (!r.createLayerView) {
                  _context.next = 18;
                  break;
                }

                _context.next = 15;
                return r.createLayerView(t, {
                  signal: e
                });

              case 15:
                _l = _context.sent;
                _context.next = 24;
                break;

              case 18:
                if (this.layerViewImporter.hasLayerViewModule(r)) {
                  _context.next = 20;
                  break;
                }

                throw new i("layer:view-not-supported", "No layerview implementation was found");

              case 20:
                _context.next = 22;
                return this.layerViewImporter.importLayerView(r);

              case 22:
                _a = _context.sent;
                w(e), _l = "default" in _a ? new _a.default({
                  layer: r,
                  view: t
                }) : new _a({
                  layer: r,
                  view: t
                });

              case 24:
                _h = function _h() {
                  _y = n(_y), _l.destroyed || _l.destroy(), _l.layer = null, _l.parent = null, _l.view = null, _this2.done = !0;
                };

                _y = p(e, _h), w(e);
                _context.prev = 26;
                _context.next = 29;
                return _l.when();

              case 29:
                _context.next = 34;
                break;

              case 31:
                _context.prev = 31;
                _context.t1 = _context["catch"](26);
                throw _h(), _context.t1;

              case 34:
                if (null == (a = this._map) || null == (s = a.allLayers) ? void 0 : s.includes(r)) {
                  _context.next = 36;
                  break;
                }

                return _context.abrupt("return", (_h(), void this._deferred.reject(new i("view:no-layerview-for-layer", "The layer has been removed from the map", {
                  layer: r
                }))));

              case 36:
                this.layerView = _l, r.emit("layerview-create", {
                  view: t,
                  layerView: _l
                }), t.emit("layerview-create", {
                  layer: r,
                  layerView: _l
                }), this.done = !0, this._deferred.resolve(_l);
                _context.next = 42;
                break;

              case 39:
                _context.prev = 39;
                _context.t2 = _context["catch"](5);
                r.emit("layerview-create-error", {
                  view: t,
                  error: _context.t2
                }), t.emit("layerview-create-error", {
                  layer: r,
                  error: _context.t2
                }), this.done = !0, this._deferred.reject(new i("layerview:create-error", "layerview creation failed", {
                  layer: r,
                  error: _context.t2
                }));

              case 42:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[5, 39], [26, 31]]);
      }));

      function start() {
        return _start.apply(this, arguments);
      }

      return start;
    }()
  }]);

  return g;
}();

var V = /*#__PURE__*/function (_t) {
  _inherits(V, _t);

  var _super = _createSuper(V);

  function V(e) {
    var _this3;

    _classCallCheck(this, V);

    _this3 = _super.call(this, e), _this3._layerLayerViewInfoMap = new Map(), _this3._watchUpdatingTracking = new v(), _this3.supportsGround = !0, _this3._preloadLayerViewModules = function () {
      var e;
      var r = null == (e = _this3.view.map) ? void 0 : e.allLayers;

      if (r) {
        var _iterator = _createForOfIteratorHelper(r),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var _i = _step.value;
            _this3.layerViewImporter.hasLayerViewModule(_i) && _this3.layerViewImporter.importLayerView(_i);
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }
    }, _this3._reschedule = function () {
      return o(_this3._workPromise) && (_this3._workPromise = y()), _this3.handles.remove("reschedule"), _this3.handles.add(c(_this3._doWork), "reschedule"), _this3._workPromise.promise;
    }, _this3._doWork = function () {
      var e, i, t;
      var a = _this3.view.map;
      if (_this3._map !== a && (_this3.clear(), _this3._map = a), o(_this3._workPromise)) return void _this3.notifyChange("updating");
      _this3.handles.remove("reschedule"), _this3.handles.remove("collection-change");
      var s = new r({
        getCollections: function getCollections() {
          return _this3._rootCollectionNames.map(function (e) {
            return _this3.get(e);
          });
        },
        getChildrenFunction: function getChildrenFunction(e) {
          return e && "layers" in e ? e.layers : null;
        }
      });
      if (!s) return _this3._workPromise.resolve(), void (_this3._workPromise = null);

      var _iterator2 = _createForOfIteratorHelper(s),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var _r = _step2.value;

          _this3._createLayerView(_r);
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      _this3._refreshCollections();

      var _iterator3 = _createForOfIteratorHelper(_this3._layerLayerViewInfoMap),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var _step3$value = _slicedToArray(_step3.value, 2),
              _r2 = _step3$value[0],
              _o = _step3$value[1];

          s.includes(_r2) || (_this3._layerLayerViewInfoMap.delete(_o.layer), _o.destroy());
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }

      var l = s.filter(function (e) {
        return "group" === e.type;
      }).map(function (e) {
        return e.layers;
      }),
          n = [null == a || null == (e = a.ground) ? void 0 : e.layers, null == a || null == (i = a.basemap) ? void 0 : i.baseLayers, null == a || null == (t = a.basemap) ? void 0 : t.referenceLayers, null == a ? void 0 : a.layers].concat(_toConsumableArray(l)).filter(function (e) {
        return !!e;
      });
      _this3.handles.add(n.map(function (e) {
        return _this3._watchUpdatingTracking.addOnCollectionChange(e, _this3._reschedule);
      }), "collection-change"), _this3._workPromise.resolve(), _this3._workPromise = null;
    };
    return _this3;
  }

  _createClass(V, [{
    key: "initialize",
    value: function initialize() {
      this.handles.add([d(this, "view.map.allLayers", "change", this._preloadLayerViewModules, this._preloadLayerViewModules), m(this.view, ["map.basemap", "map.ground", "map.layers", "ready"], this._reschedule, !0)]), this._preloadLayerViewModules(), this._reschedule();
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.clear(), this._watchUpdatingTracking.destroy(), this._map = null;
    }
  }, {
    key: "_layersToLayerViews",
    get: function get() {
      var e = [["view.map.basemap.baseLayers", "view.basemapView.baseLayerViews"], ["view.map.layers", "view.layerViews"], ["view.map.basemap.referenceLayers", "view.basemapView.referenceLayerViews"]];
      return this.supportsGround && e.push(["view.map.ground.layers", "view.groundView.layerViews"]), new Map(e);
    }
  }, {
    key: "_rootCollectionNames",
    get: function get() {
      return Array.from(this._layersToLayerViews.keys());
    }
  }, {
    key: "updating",
    get: function get() {
      return l(this._workPromise) || this._watchUpdatingTracking.updating || s(this._layerLayerViewInfoMap, function (e) {
        return !e.done;
      });
    }
  }, {
    key: "updatingRemaining",
    get: function get() {
      var e = 0;

      var _iterator4 = _createForOfIteratorHelper(this._layerLayerViewInfoMap.values()),
          _step4;

      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var _r3 = _step4.value;
          _r3.done || ++e;
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }

      return e;
    }
  }, {
    key: "clear",
    value: function clear() {
      if (!this.destroyed) {
        var _iterator5 = _createForOfIteratorHelper(this._layerLayerViewInfoMap.values()),
            _step5;

        try {
          for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
            var _e = _step5.value;

            _e.destroy();
          }
        } catch (err) {
          _iterator5.e(err);
        } finally {
          _iterator5.f();
        }

        this._layerLayerViewInfoMap.clear(), this._refreshCollections();
      }
    }
  }, {
    key: "whenLayerView",
    value: function () {
      var _whenLayerView = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(e) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this._reschedule();

              case 2:
                if (this._layerLayerViewInfoMap.has(e)) {
                  _context2.next = 4;
                  break;
                }

                throw new i("view:no-layerview-for-layer", "No layerview has been found for the layer", {
                  layer: e
                });

              case 4:
                return _context2.abrupt("return", this._layerLayerViewInfoMap.get(e).promise);

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function whenLayerView(_x) {
        return _whenLayerView.apply(this, arguments);
      }

      return whenLayerView;
    }()
  }, {
    key: "_refreshCollections",
    value: function _refreshCollections() {
      var _iterator6 = _createForOfIteratorHelper(this._layersToLayerViews),
          _step6;

      try {
        for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
          var _step6$value = _slicedToArray(_step6.value, 2),
              _e2 = _step6$value[0],
              _r4 = _step6$value[1];

          this._populateLayerViewsOwners(this.get(_e2), this.get(_r4), this.view);
        }
      } catch (err) {
        _iterator6.e(err);
      } finally {
        _iterator6.f();
      }

      this.notifyChange("updating"), this.notifyChange("updatingRemaining");
    }
  }, {
    key: "_populateLayerViewsOwners",
    value: function _populateLayerViewsOwners(e, r, i) {
      if (!e || !r) return void (r && r.removeAll());
      var t = 0;

      var _iterator7 = _createForOfIteratorHelper(e),
          _step7;

      try {
        for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
          var a = _step7.value;

          var _e3 = this._layerLayerViewInfoMap.get(a);

          if (!_e3 || !_e3.layerView) continue;
          var _s = _e3.layerView;
          _s.layer = a, _s.parent = i, r.getItemAt(t) !== _s && r.splice(t, 0, _s), a.layers && this._populateLayerViewsOwners(a.layers, _s.layerViews, _s), t += 1;
        }
      } catch (err) {
        _iterator7.e(err);
      } finally {
        _iterator7.f();
      }

      t < r.length && r.splice(t, r.length);
    }
  }, {
    key: "_createLayerView",
    value: function _createLayerView(e) {
      var _this4 = this;

      if (this._layerLayerViewInfoMap.has(e)) return this.view.ready && this._layerLayerViewInfoMap.get(e).start(), this.notifyChange("updating"), void this.notifyChange("updatingRemaining");
      e.load().catch(function () {}), this.layerViewImporter.hasLayerViewModule(e) && this.layerViewImporter.importLayerView(e);
      var r = new g(e, this.view, this.layerViewImporter);
      r.promise.then(function () {
        return _this4._refreshCollections();
      }, function (r) {
        var i, t;
        r && (h(r) || "cancelled:layerview-create" === r.name) || _.error("Failed to create layerview for layer title:'".concat(null != (i = e.title) ? i : "no title", "', id:'").concat(null != (t = e.id) ? t : "no id", "' of type '").concat(e.type, "'."), {
          layer: e,
          error: r
        });

        _this4._refreshCollections();
      }), this._layerLayerViewInfoMap.set(e, r), this.view.ready && r.start(), this.notifyChange("updating"), this.notifyChange("updatingRemaining");
    }
  }]);

  return V;
}(t);

e([u()], V.prototype, "_workPromise", void 0), e([u({
  readOnly: !0
})], V.prototype, "_watchUpdatingTracking", void 0), e([u({
  readOnly: !0
})], V.prototype, "_layersToLayerViews", null), e([u({
  readOnly: !0
})], V.prototype, "_rootCollectionNames", null), e([u()], V.prototype, "layerViewImporter", void 0), e([u()], V.prototype, "supportsGround", void 0), e([u({
  readOnly: !0
})], V.prototype, "updating", null), e([u({
  readOnly: !0
})], V.prototype, "updatingRemaining", null), e([u({
  constructOnly: !0
})], V.prototype, "view", void 0), V = e([f("esri.views.LayerViewManager")], V);
var L = V;
export { L as default };